import { render, staticRenderFns } from "./EventsStat.vue?vue&type=template&id=d7b8e510&scoped=true"
import script from "./EventsStat.vue?vue&type=script&lang=js"
export * from "./EventsStat.vue?vue&type=script&lang=js"
import style0 from "./EventsStat.vue?vue&type=style&index=0&id=d7b8e510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b8e510",
  null
  
)

export default component.exports